<script setup>
import ObjectiveTable from '@frontJs/components/tables/projectManagement/tasks/tenantReports/ObjectiveTable.vue';
import ProjectManagementLayout from '@frontJs/layouts/ProjectManagementLayout.vue';
import { Head } from '@inertiajs/vue3';
import TabLayout from '@js/components/tabs/TabLayout.vue';
import PageTitle from '@js/components/titles/PageTitle.vue';
import { h } from 'vue';

defineOptions({ layout: ProjectManagementLayout });
</script>

<template>
    <Head>
        <title>Objectifs - Tâches - Gestion de projet - Datakepler</title>
    </Head>

    <PageTitle>Gestion de projet - Tâches - Objectifs</PageTitle>

    <TabLayout
        :tabs="{
            overview: {
                title: 'Récap',
                content: h(ObjectiveTable, {
                    overview: true,
                }),
            },
            seoAndGeo: {
                title: 'SEO/GEO',
                content: h(ObjectiveTable, {
                    seo: true,
                }),
            },
            sea: {
                title: 'SEA',
                content: h(ObjectiveTable, {
                    sea: true,
                }),
            },
            sma: {
                title: 'SMA',
                content: h(ObjectiveTable, {
                    sma: true,
                }),
            },
            smo: {
                title: 'SMO',
                content: h(ObjectiveTable, {
                    smo: true,
                }),
            },
            sem: {
                title: 'SEM',
                content: h(ObjectiveTable, {
                    sem: true,
                }),
            },
            cs: {
                title: 'CS',
                content: h(ObjectiveTable, {
                    cs: true,
                }),
            },
        }"
    />
</template>
